import Navbar from "@/components/Navbar";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/admin/login", form);
      localStorage.setItem("admin_token", r.data.token);
      toast.success("Welcome back");
      nav("/admin/dashboard");
    } catch { toast.error("Invalid credentials"); }
    setBusy(false);
  };

  return (
    <div data-testid="admin-login">
      <Navbar/>
      <div className="pt-40 pb-20 px-6 max-w-md mx-auto">
        <div className="card-dark p-10">
          <div className="w-14 h-14 rounded-full border border-[#5DCFE5] flex items-center justify-center mb-6">
            <Lock size={20} className="text-[#5DCFE5]"/>
          </div>
          <p className="eyebrow mb-2">Admin</p>
          <h1 className="font-serif text-3xl mb-2">Welcome back</h1>
          <div className="divider"/>
          <form onSubmit={submit} className="space-y-4 mt-6">
            <input data-testid="admin-email" required type="email" placeholder="Email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} className="input-dark"/>
            <input data-testid="admin-password" required type="password" placeholder="Password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} className="input-dark"/>
            <button data-testid="admin-login-btn" disabled={busy} className="btn-gold w-full justify-center">{busy ? "Signing in..." : "Sign In"}</button>
          </form>
        </div>
      </div>
    </div>
  );
}
